import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AGGREGATED_DATA_SERVICE_TOKEN, IAggregatedDataService } from '../../models/data/aggregated-data.interface';
import { RdSAPSurveyDetailsService } from '../../../core-state/services/collection/rdsap-survey-details.service';
import { RdSAPHealthService } from '../../../core-state/services/collection/rd-sap-health.service';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckService {
  private status = new BehaviorSubject<boolean>(true);
  public status$ = this.status.asObservable();

  constructor(
    @Inject(AGGREGATED_DATA_SERVICE_TOKEN) private aggregatedDataService: IAggregatedDataService,
    private rdSAPDetailsService: RdSAPSurveyDetailsService,
    private healthInfoService: RdSAPHealthService
  ) {

  }

  checkHealth(): void {
    console.log('Checking health');
    combineLatest([
      this.aggregatedDataService.rdSAPHealth$.pipe(catchError(() => of([]))),
      this.rdSAPDetailsService.loading$,
      this.healthInfoService.loading$,
    ]).pipe(
      map((results) => {
        if (!Array.isArray(results)) {
          return false;
        }

        const allElementsAreLoading = results.some(innerArray => (!Array.isArray(innerArray) && innerArray === true));
        if (allElementsAreLoading) {
          return true;
        }

        const allElementsAreArrays = results.every(innerArray => (Array.isArray(innerArray) && innerArray.length > 0) || innerArray === false);

        if (!allElementsAreArrays) {
          return false;
        }

        const isUnhealthy = results.some(innerArray => Array.isArray(innerArray) && innerArray.length === 0);
        return !isUnhealthy;
      })
    ).subscribe((isHealthy: boolean) => {
      this.status.next(isHealthy);
    });
  }
}
